import React from "react";
import s from "./RecordDetail.module.scss";

const RecordDetail = ({
  label,
  labelStyle,
  dataStyle,
  data,
  clickData,
  clickDataFn,
}) => {
  return (
    <div className={s.recordDetailContainer}>
      <div className={s.detailLabel}>
        <span style={labelStyle}>{label}</span>
      </div>
      {clickData && clickDataFn ? (
        <div className={s.detailData}>
          <span style={dataStyle} onClick={clickDataFn}>
            {data}
          </span>
        </div>
      ) : (
        <div className={s.detailData}>
          <span style={dataStyle}>{data}</span>
        </div>
      )}
    </div>
  );
};

export default React.memo(RecordDetail);
